import { __extends } from 'tslib';
import * as React from 'react';
import HeightReporter from 'react-height';
import { spring, Motion } from 'react-motion';

var stringHeight = function (height) { return Math.max(0, parseFloat("" + height)).toFixed(1); };
var Collapse = (function (_super) {
    __extends(Collapse, _super);
    function Collapse(props) {
        var _this = _super.call(this, props) || this;
        _this.onHeightReady = function (height) {
            if (_this.renderStatic && _this.props.isOpened) {
                _this.height = stringHeight(height);
            }
            _this.setState({
                height: _this.props.isOpened || !_this.renderStatic ? height : Math.min(height, _this.props.defaultHeight),
            });
        };
        _this.state = {
            height: -1,
            isOpenedChanged: false,
        };
        return _this;
    }
    Collapse.prototype.UNSAFE_componentWillMount = function () {
        this.height = stringHeight(this.props.defaultHeight);
        this.renderStatic = true;
    };
    Collapse.prototype.UNSAFE_componentWillReceiveProps = function (nextProps) {
        this.setState({
            isOpenedChanged: nextProps.isOpened !== this.props.isOpened,
        });
    };
    Collapse.prototype.getMotionHeight = function (height) {
        var newHeight = this.props.isOpened
            ? Math.max(0, parseFloat("" + height)).toFixed(1)
            : stringHeight(Math.min(height, this.props.defaultHeight));
        var skipAnimation = (!this.state.isOpenedChanged && !this.props.isOpened) || this.height === newHeight;
        var springHeight = spring(this.props.isOpened ? Math.max(0, height) : Math.min(height, this.props.defaultHeight), {
            precision: 0.5,
            damping: 26,
            stiffness: 200,
        });
        var instantHeight = this.props.isOpened ? Math.max(0, height) : Math.min(height, this.props.defaultHeight);
        return skipAnimation ? instantHeight : springHeight;
    };
    Collapse.prototype.render = function () {
        var _this = this;
        var _a = this.props, isOpened = _a.isOpened, onRest = _a.onRest, defaultHeight = _a.defaultHeight;
        var style;
        var renderStatic = this.renderStatic;
        var height = this.state.height;
        var currentStringHeight = parseFloat("" + height).toFixed(1);
        if (height > -1 && renderStatic) {
            this.renderStatic = false;
        }
        var content = React.createElement(HeightReporter, { onHeightReady: this.onHeightReady }, this.props.children);
        if (renderStatic) {
            style = isOpened ? { height: '100%' } : { overflow: 'hidden', height: defaultHeight };
            if (!isOpened && height > -1) {
                return React.createElement("div", { style: { height: height, overflow: 'hidden' } }, content);
            }
            return (React.createElement(Motion, { defaultStyle: { height: Math.max(0, height) }, style: { height: Math.max(0, height) }, onRest: onRest }, function () { return React.createElement("div", { style: style }, content); }));
        }
        return (React.createElement(Motion, { defaultStyle: { height: Math.max(defaultHeight, height) }, onRest: onRest, style: { height: this.getMotionHeight(height) } }, function (state) {
            _this.height = stringHeight(state.height);
            var style = isOpened && _this.height === currentStringHeight
                ? { height: '100%' }
                : {
                    height: state.height,
                    overflow: 'hidden',
                };
            return React.createElement("div", { style: style }, content);
        }));
    };
    return Collapse;
}(React.PureComponent));

export { Collapse as default };
//# sourceMappingURL=Collapse.js.map
